import { render, staticRenderFns } from "./y_upload_audio.vue?vue&type=template&id=1c6b2c90&scoped=true"
import script from "./y_upload_audio.vue?vue&type=script&lang=js"
export * from "./y_upload_audio.vue?vue&type=script&lang=js"
import style1 from "./y_upload_audio.vue?vue&type=style&index=1&id=1c6b2c90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6b2c90",
  null
  
)

export default component.exports